// extracted by mini-css-extract-plugin
export default {"section":"B0VX3HJJaeVjIwgrFuMz","sectionTitle":"AsyUC6L30xtzlnhXLLnM","topCities":"H5UYTu5fxJMlL4n1SQlM"};